import Button from '@rio-cloud/rio-uikit/Button';
import { FormattedMessage } from 'react-intl';

import { getCustomerCenterPath } from '../../common/routes';
import { CustomerCenterTab } from '../../customerCenter/types';
import manPointingUp from '../images/man_pointing_up.webp';
import { ProductImageSlider } from './ProductImageSlider';

export function SuccessScreen() {
    const close = () => {
        window.open(getCustomerCenterPath(CustomerCenterTab.FREE_TRIAL), '_blank');
        window.close();
    };

    return (
        <div className='module-content-wrapper bg-primary'>
            <div className='module-content padding-top-20 padding-x-0 min-height-100vh'>
                <div
                    className={
                        'width-100pct max-width-800 rounded-circle bg-white aspect-ratio-1 position-absolute top-0 left-50pct translate-x-50pct-y-50pct opacity-30 blur-50'
                    }
                />
                <div>
                    <div className='text-center text-size-h1 text-bold'>
                        <FormattedMessage id={'intl-msg:marketplace.freeTrial.success.headline'} />
                    </div>
                    <div className='text-center text-size-20'>
                        <FormattedMessage id={'intl-msg:marketplace.freeTrial.success.text'} />
                    </div>
                    <div className='text-center text-size-16'>
                        <FormattedMessage
                            id={'intl-msg:marketplace.freeTrial.success.eulaNotice'}
                            values={{
                                eulaLink: (
                                    <Button
                                        as='a'
                                        href='https://man-eula.iam.rio.cloud'
                                        className='btn btn-secondary btn-link btn-link-inline'
                                        target='_blank'
                                        rel='noreferrer'
                                        autoTrackingKey={'marketplace.freeTrial.success.eulaNotice'}
                                    >
                                        EULA
                                    </Button>
                                ),
                            }}
                        />
                    </div>
                    <ProductImageSlider />
                    <div className='display-flex justify-content-center'>
                        <Button
                            type='button'
                            className='btn btn-secondary btn-lg translate-y-50pct'
                            onClick={close}
                            autoTrackingKey={'marketplace.freeTrial.success.button'}
                        >
                            <FormattedMessage id={'intl-msg:marketplace.freeTrial.success.button'} />
                        </Button>
                    </div>
                </div>
                <img
                    className='img-responsive position-absolute bottom-0 left-50pct width-450 translate-x-50pct'
                    alt='Man pointing up'
                    src={manPointingUp}
                />
            </div>
        </div>
    );
}
